import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import { IconConnection } from '../../Atoms/Icon';
import { isEmptyObject } from '../../lib/utils/helpers';
import { getIsConnected } from '../../Templates/TerminalHome/Wan/connection';

import {
  getConnectedFontSize,
  getDisconnectedFontSize,
} from './connectionSizes';
import styles from './tcmStatus.module.css';

export const ConnectionsList = ({
  activeKey = '',
  selectedMode = '',
  size = 'sm',
  isAlternateOrBackup = false,
  ...props
}) => {
  const connectedSize = getConnectedFontSize(size);
  const disconnectedSize = getDisconnectedFontSize(size);

  const connections = ['vsat', 'cell', 'wifi'];

  const coreConnections = [];
  connections.forEach((name) => {
    if (props[name] && !isEmptyObject(props[name])) {
      coreConnections.push(name);
    }
  });
  if (isAlternateOrBackup && selectedMode === 'manual') {
    const optionalConnections = ['alternate', 'backup'];
    optionalConnections.forEach((name) => {
      if (activeKey === name && props[name] && !isEmptyObject(props[name])) {
        coreConnections.push(name);
      }
    });
  }

  if (coreConnections.length === 0) {
    return (
      <div
        key="no_connections"
        className={classNames(styles.noConnections, 'text-gray-600')}
        style={{ fontSize: size === 'lg' ? '12px' : '' }}
      >
        NO CONNECTIONS
      </div>
    );
  }

  return coreConnections.map((name) => {
    if (selectedMode === 'manual' && name !== activeKey) {
      return '';
    }

    const isConnected = getIsConnected(props[name].connectionStatus);

    return (
      <div
        className="d-flex align-items-center justify-content-center"
        key={name}
      >
        <IconConnection
          name={name}
          isConnected={isConnected}
          isActive={activeKey === name}
          style={{
            fontSize: isConnected ? connectedSize : disconnectedSize,
          }}
        />

        {selectedMode &&
          selectedMode === 'manual' &&
          coreConnections.length > 1 && (
            <span
              className={classNames(styles.only, 'text-gray-600')}
              style={{ fontSize: size === 'lg' ? '12px' : '' }}
            >
              ONLY
            </span>
          )}
      </div>
    );
  });
};

ConnectionsList.propTypes = {
  activeKey: PropTypes.oneOf(['vsat', 'cell', 'wifi', 'alternate', 'backup']),
  selectedMode: PropTypes.oneOf(['auto', 'manual']),
  size: PropTypes.oneOf(['sm', 'lg']),
  isAlternateOrBackup: PropTypes.bool,
  vsat: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  cell: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  wifi: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  alternate: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  backup: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
};
